import styled from '@emotion/styled'
import { modalXPadding } from '../../Quickbet.styles'

export const QuickbetKeypadWrapperStyled = styled('div')({
  margin: `0 -${modalXPadding}`,
  paddingBottom: '0.2rem',
})
